import React from 'react';
import { InfoTooltip } from './Tooltips/InfoTooltip';

const TextField = ({
  label,
  placeholder,
  value,
  onChange,
  className,
  classNameInput,
  disabled,
  type = 'text',
  star,
  validation,
  tooltip,
  tooltipType,
  tooltipLabel,
}) => (
  <div className={`w-full flex flex-col ${className} ${disabled ? 'opacity-75' : ''}`}>
    {label && (
      <label
        className={`uppercase tracking-wide ${
          classNameInput ? 'text-gray-400' : 'text-gray-600'
        } text-xs font-semibold mb-2`}
      >
        <div className="flex flex-row gap-2 items-center">
          {label}
          {star && <span>*</span>}
          {tooltip && <InfoTooltip placement={tooltip} data={tooltipType} label={tooltipLabel} />}
        </div>
      </label>
    )}
    <input
      className={`
      appearance-none block w-full
      rounded py-3 px-4 leading-tight
      focus:outline-none focus:bg-[#F8FAFC] focus:border-[#A0AEC0]`}
      style={{
        // background: disabled ? '#EDF2F7 !important' : '#EDF2F7',
        // eslint-disable-next-line no-nested-ternary
        border: disabled
          ? 'none !important'
          : validation
          ? '1px solid #fc8181 !important'
          : '1px solid #edf2f7 !important',
      }}
      type={type}
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

export default TextField;
